import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { getProductRoute } from '../utils/productRoutes';
import './MarketDetailPage.css';

const MarketDetailPage = () => {
  const { marketId } = useParams();

  const marketData = {
    'fmcg': {
      name: 'FMCG',
      icon: 'fas fa-shopping-basket',
      description: 'Reliable, food-safe and high-clarity packaging for fast-moving consumer goods — from groceries and edibles to everyday household products.',
      detailedDescription: 'Our FMCG packaging solutions meet BRC and food-grade standards, ensuring product integrity, premium shelf appeal and dependable performance across high-volume retail and distribution channels.',
      products: ['BOPP Laminated Bags', 'PP Woven Bags', 'Laminated Woven Bags'],
      color: '#10b981'
    },
    'mining-minerals': {
      name: 'Mining & Minerals',
      icon: 'fas fa-mountain',
      description: 'Heavy-duty bags designed for mining and mineral industries. Our robust packaging solutions are engineered to withstand the demanding conditions of mining operations.',
      detailedDescription: 'We understand the unique challenges of the mining and minerals industry. Our packaging solutions are designed to handle heavy loads, resist abrasion, and protect valuable mineral products during transport and storage.',
      products: ['FIBC', 'PP Woven Bags', 'Laminated Woven Bags'],
      color: '#f59e0b'
    },
    'seed-crops': {
      name: 'Seed & Crops',
      icon: 'fas fa-seedling',
      description: 'When it comes to seed and crops, we offer you safe, reliable and qualitative transport packaging for your valuable products.',
      detailedDescription: 'We offer breathable, durable bag formats that keep agricultural produce — seeds, grains, potatoes, onions and more — protected from moisture and contamination during storage and transport. We make every effort to ensure that your product is contained safely in our packaging.',
      products: ['PP Woven Bags', 'BOPP Laminated Bags', 'Laminated Woven Bags', 'FIBC'],
      color: '#84cc16'
    },
    'animal-nutrition': {
      name: 'Animal Nutrition',
      icon: 'fas fa-paw',
      description: 'Animal feed packaging with food-grade standards to ensure safe and hygienic storage of animal nutrition products.',
      detailedDescription: 'We provide food-grade packaging solutions for animal feed and nutrition products. Our bags maintain product quality, prevent contamination, and ensure safe handling of animal nutrition supplies.',
      products: ['BOPP Laminated Bags', 'PP Woven Bags', 'Laminated Woven Bags'],
      color: '#f97316'
    },
    'construction': {
      name: 'Construction',
      icon: 'fas fa-hard-hat',
      description: 'Construction-grade packaging and protection materials designed to meet the rigorous demands of the construction industry.',
      detailedDescription: 'Our construction packaging solutions are built to handle heavy materials, resist weather conditions, and provide reliable protection for construction supplies during transport and on-site storage.',
      products: ['FIBC', 'PP Woven Bags', 'Laminated Woven Bags'],
      color: '#ef4444'
    }
  };

  const market = marketData[marketId];

  if (!market) {
    return (
      <div className="App">
        <Header />
        <div className="market-not-found">
          <h2>Market Not Found</h2>
          <Link to="/" className="btn btn-primary">Back to Home</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <div className="market-detail-page">
        <div className="container">
          {/* Breadcrumb */}
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Markets Served</span>
            <span>/</span>
            <span>{market.name}</span>
          </div>

          {/* Market Header */}
          <div className="market-header">
            <div className="market-icon-large" style={{ backgroundColor: market.color }}>
              <i className={market.icon}></i>
            </div>
            <h1>{market.name}</h1>
          </div>

          {/* Market Description */}
          <div className="market-description">
            <p className="market-intro">{market.description}</p>
            {market.detailedDescription && (
              <p className="market-detailed">{market.detailedDescription}</p>
            )}
          </div>

          {/* Products Section */}
          <div className="market-products-section">
            <h2>The products of your interest are:</h2>
            <div className="products-grid">
              {market.products.map((product, index) => (
                <Link
                  key={index}
                  to={getProductRoute(product)}
                  className="product-tile"
                >
                  <div className="product-tile-content">
                    <i className="fas fa-box"></i>
                    <h3>{product}</h3>
                    <span className="product-link">View Product <i className="fas fa-arrow-right"></i></span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* Custom Solution CTA */}
          <div className="custom-solution-cta">
            <div className="cta-content">
              <h3>Need a Custom Solution?</h3>
              <p>
                We specialize in creating tailored packaging solutions for unique industry requirements. 
                If you have customized requirements, let us help you find the solution that best fits your needs.
              </p>
              <Link to="/#contact" className="btn btn-primary">Contact Our Experts</Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MarketDetailPage;

